import { observer } from 'mobx-react-lite'
import type { RoutingPlansBuilderViewModel } from '@/features/legends/routing/RoutingPlansBuilderViewModel'
import { RoutingPlanRow } from '@/features/legends/routing/components/RoutingPlanRow'
import { RoutingPlans } from '@/features/legends/routing/components/RoutingPlans'

export interface RoutingPlansContainerProps {
  vm: RoutingPlansBuilderViewModel
  testId?: string
}

export const RoutingPlansContainer = observer(function RoutingPlansContainer({
  vm,
  testId,
}: RoutingPlansContainerProps) {
  return (
    <RoutingPlans
      isEmpty={vm.plans.length === 0}
      onAdd={vm.canAddPlan ? vm.add : undefined}
      isDisabled={vm.isEditingDisabled}
      testId={testId}
    >
      {vm.plans.map((planVm, index) => (
        <RoutingPlanRow
          key={planVm.cid}
          index={index}
          label={planVm.label}
          description={planVm.description}
          duration={planVm.duration}
          isSelected={vm.selectedPlanVm === planVm}
          hasError={!planVm.validation.isValid}
          isDisabled={vm.isEditingDisabled}
          onPress={() => vm.select(planVm)}
          onRemove={() => vm.remove(planVm)}
          onMove={vm.moveByIndex}
          testId={testId && `${testId}-${index}`}
        />
      ))}
    </RoutingPlans>
  )
})
